import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";
import ObjectOverride from "components/ObjectOverride";
import API from "@beardeddevops/react.api";
import {Button} from "reactstrap";
import APPCONFIG from "../../constants/Config";

export default class Custom_Export_2669 extends ObjectOverride {
	constructor(props) {
		super(props, Types.Custom_Modules._name);
	}

	form = () => {
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>

						<div className={"col-md"}>
							<h4 className="section-title">Custom Exports</h4>

							<div className="form-group">
								<a style={{marginRight: '25px'}}
									target={'_blank'}
									href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/custom_modules/export_instock`}
								>
									<Button color={"primary"}>
										In-Stock CSV Report
									</Button>
								</a>
								<a style={{marginRight: '25px'}}
									target={'_blank'}
									href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/custom_modules/export_transferred`}
								>
									<Button color={"primary"}>
										Transferred CSV Report
									</Button>
								</a>
								<a style={{marginRight: '25px'}}
									target={'_blank'}
									href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/custom_modules/export_destroyed`}
								>
									<Button color={"primary"}>
										Destroyed CSV Report
									</Button>
								</a>
								<a style={{marginRight: '25px'}}
								   target={'_blank'}
									href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/custom_modules/export_serial_numbers`}
								>
									<Button color={"primary"}>
										Serial Numbers Report
									</Button>
								</a>
							</div>
						</div>

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
